/**
 * ReportsHarvestInspectionsCardGroup
 */
import React from 'react';

// Components
import ReportsHarvestInspectionsAverageCountSizeCard from './components/ReportsHarvestInspectionsAverageCountSizeCard';
import ReportsHarvestInspectionsOverallDefectPercentageCard from './components/ReportsHarvestInspectionsOverallDefectPercentageCard';
import ReportsHarvestInspectionsTotalCard from './components/ReportsHarvestInspectionsTotalCard';

interface Props {
    jobType?: string;
}

export default class ReportsHarvestInspectionsCardGroup extends React.PureComponent<Props> {
    render() {
        const { jobType } = this.props;
        return (
            <React.Fragment>
                {jobType === 'INSPECTION' && (
                    <React.Fragment>
                        <ReportsHarvestInspectionsAverageCountSizeCard />
                        <ReportsHarvestInspectionsOverallDefectPercentageCard />
                        <ReportsHarvestInspectionsTotalCard
                            title="# Inspections"
                            field="numberOfInspections"
                        />
                    </React.Fragment>
                )}
                {jobType === 'TIMESHEET' && (
                    <React.Fragment>
                        <ReportsHarvestInspectionsTotalCard
                            title="# Bins Checked"
                            field="numberOfContainers"
                        />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}
